import React, { useEffect, useState } from 'react'
import axiosInstance from '../../utils/Api'
import "../profile/Profile.css"

const defaultContactDetails = {
    email: "contact@magikmat.com",
    phone: "+91 72004 72006"
}

const Contact = () => {
    const [contactDetails, setContactDetails] = useState(defaultContactDetails)

    useEffect(() => {
        let isMounted = true

        axiosInstance.get("online/contact", { timeout: 10000 })
            .then(({ data }) => {
                if (!isMounted || data?.status !== true || !data?.data) return

                setContactDetails({
                    email: typeof data.data.email === "string" && data.data.email.trim()
                        ? data.data.email
                        : defaultContactDetails.email,
                    phone: typeof data.data.phone === "string" && data.data.phone.trim()
                        ? data.data.phone
                        : defaultContactDetails.phone
                })
            })
            .catch((error) => {
                console.error("Failed to load contact details. Using default contact details.", error)
            })

        return () => {
            isMounted = false
        }
    }, [])

    return (
        <div className='Profile-main'>
            <div className="Profile-details">
                <p className="Profile-heading-info">Contact US</p>
                <div className="Profile-img-box-1">
                    <div className="input-box">
                        <div className="text-1">
                            <span className="Phone-number-text">Email</span>
                            <input
                                className="Mobile-number-1"
                                disabled
                                value={contactDetails.email}
                            />
                        </div>
                        <div className="text-1">
                            <span className="Phone-number-text">Phone Number</span>
                            <input
                                className="Mobile-number-1"
                                disabled
                                value={contactDetails.phone}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact